import { getCustomIntegrationsPaginated, getDatamateIntegrations } from "@/helpers/apis";
import { useQuery } from "@tanstack/react-query";
import { GET_DATAMATES_CUSTOM_INTEGRATIONS } from "../query/constants";
import { useAppState } from "@/modules/app/useAppContext";

const useIntegrations = () => {
  const { loggedinUser } = useAppState();
  const { data: customIntegrations, isLoading: isCustomIntegrationsLoading } = useQuery({
    queryKey: [GET_DATAMATES_CUSTOM_INTEGRATIONS],
    queryFn: () =>
      getCustomIntegrationsPaginated({
        page: 1,
        size: 100,
      }),
    enabled: !!loggedinUser,
    staleTime: 5 * 60 * 1000, // Data stays fresh for 5 minutes (no refetch on remount)
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
  });
  const { data: integrationsFromServer, isLoading: isIntegrationsFromServerLoading } = useQuery({
    queryKey: ["datamate_integrations"],
    queryFn: () => getDatamateIntegrations(),
    enabled: !!loggedinUser,
    staleTime: 5 * 60 * 1000, // Data stays fresh for 5 minutes (no refetch on remount)
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
  });

  const allIntegrations = [...(customIntegrations?.items ?? []), ...(integrationsFromServer || [])];

  const getIntegration = (id: string) => {
    return allIntegrations.find(i => i.id === id);
  };

  return {
    getIntegration,
    allIntegrations,
    customIntegrations,
    integrationsFromServer,
    isCustomIntegrationsLoading,
    isIntegrationsFromServerLoading,
  };
};

export default useIntegrations;
